import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ProductTierPricePoint.Import.IRequest;
type Headers = Api.Core.ProductTierPricePoint.Import.IHeaders;
type Response = Api.Core.ProductTierPricePoint.Import.IResponse;
const url = '/api/ProductManagement/ProductTierPricePoint/ImportFromExcel/:productId';
export async function productTierPricePointImportFromExcelApi(body: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.put,
    body,
    url: createPathFromRoute(url, { productId: body.productId }, null),
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
